<div class="tw-container tw-mx-auto">
  <div
    class="tw-mt-6 tw-w-full tw-rounded-3xl tw-bg-color-surface-card tw-py-8 tw-px-12 shadow-fade-card sm:tw-px-8 sm:tw-mt-0"
  >
    <p class="tw-text-center tw-font-medium tw-text-[14px] tw-mb-3">
      {{ "deviceApprovalRequiredTitle" | i18n }}
    </p>

    @if (state === "loading" || state === "unlocking") {
      <div class="tw-flex tw-flex-col tw-items-center tw-gap-2 tw-py-8">
        <i class="bwi bwi-spinner bwi-spin tw-text-2xl" aria-hidden="true"></i>
        <p>{{ "loading" | i18n }}</p>
      </div>
    } @else if (state === "waiting") {
      <p class="tw-text-center tw-text-color-text-secondary tw-text-[12px] tw-mb-4">
        {{ "deviceApprovalRequiredBody" | i18n }}
      </p>
      <div class="tw-mb-4">
        <label class="tw-font-semibold tw-text-[14px] tw-text-color-text-tertiary">{{
          "fingerprintPhraseHeader" | i18n
        }}</label>
        <p
          data-testid="deviceApprovalFingerprintPhrase"
          class="tw-bg-color-surface-input tw-font-mono tw-text-[12px] tw-w-full tw-rounded-lg tw-px-3 tw-py-2 tw-break-words"
        >
          {{ fingerprintPhrase }}
        </p>
        <p class="tw-text-color-text-secondary tw-text-[12px] tw-mt-1">
          {{ "deviceApprovalFingerprintHint" | i18n }}
        </p>
      </div>
      <div class="tw-flex tw-items-center tw-justify-center tw-gap-2 tw-mb-6">
        <i class="bwi bwi-spinner bwi-spin" aria-hidden="true"></i>
        <p class="tw-text-[12px]">{{ "deviceApprovalWaiting" | i18n }}</p>
      </div>
    } @else {
      <p
        data-testid="deviceApprovalResultMessage"
        class="tw-text-center tw-text-color-status-error-text tw-text-[12px] tw-mb-6"
      >
        @switch (state) {
          @case ("denied") {
            {{ "deviceApprovalDenied" | i18n }}
          }
          @case ("expired") {
            {{ "deviceApprovalExpired" | i18n }}
          }
          @case ("unlockFailed") {
            {{ "deviceApprovalUnlockFailed" | i18n }}
          }
          @case ("alreadyTrusted") {
            {{ "deviceApprovalUnlockFailed" | i18n }}
          }
          @case ("rateLimited") {
            {{ "deviceApprovalRateLimited" | i18n }}
          }
          @default {
            {{ "errorOccurred" | i18n }}
          }
        }
      </p>
      @if (canRequestAgain) {
        <app-gloss-button
          class="tw-block tw-mb-3"
          [options]="{
            text: 'deviceApprovalRequestAgain' | i18n,
            type: 'none',
            fullClass: 'tw-bg-dt-custom-teal-11 tw-h-12 tw-w-full tw-px-6 tw-rounded-full',
            onClick: requestApproval.bind(this),
            isEnabled: true,
            testId: 'deviceApprovalRequestAgainButton',
          }"
        >
        </app-gloss-button>
      }
    }

    <app-gloss-button
      [options]="{
        text: 'logOut' | i18n,
        type: 'none',
        fullClass: 'tw-bg-dt-custom-teal-11 tw-h-12 tw-w-full tw-px-6 tw-rounded-full',
        onClick: logOut.bind(this),
        isEnabled: true,
        testId: 'deviceApprovalRequiredLogOutButton',
      }"
    >
    </app-gloss-button>
  </div>
</div>
